// extracted by mini-css-extract-plugin
export default {"control":"language_control__Ql11P","label":"language_label__0M0PY","icon":"language_icon__WT2c5"};